import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Typography } from '@mui/material';
//
import { BaseOptionChart } from '../../dash_charts/BaseOptionChart'
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

var pt = require("apexcharts/dist/locales/pt.json");

const CHART_DATA = [
    {
    name: 'Correta',
    type: 'area',
    data: [8,8,6,7,5,4,5,6,7,10,11,11]
    },
  {
    name: 'Desvio do Eixo do Movimento',
    type: 'area',
    data: [9,8,7,8,10,5,7,6,4,3,2,2]
  },
  {
    name: 'Movimentos Compensatórios',
    type: 'area',
    data: [11,12,11,18,16,11,7,15,13,12,10,9]
  },
];

export default function HarmoniaGestoExercicios() {
    const theme = useTheme();

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      locales: [pt],
      defaultLocale: 'pt',
    },
    
    colors: [
        theme.palette.primary.main,
        theme.palette.warning.main,
        theme.palette.error.main,
      ],
    stroke: { 
      width: [2,3,3],
      curve: 'smooth'
    },
    plotOptions: { 
      bar: { columnWidth: '11%', borderRadius: 4 } 
    },
    fill: { 
      type: 'gradient',
    },
    labels: [
      '01/01/2021',
      '02/01/2021',
      '03/01/2021',
      '04/01/2021',
      '05/01/2021',
      '06/01/2021',
      '07/01/2021',
      '08/01/2021',
      '09/01/2021',
      '10/01/2021',
      '11/01/2021',
      '12/01/2021'
    ],
    xaxis: { 
      type: 'datetime' 
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} `; // write something
          }
          return y;
        }
      }
    }
  });

  return (
    
    <Typography variant="h6">Harmonia do Gesto
    <ReactApexChart type="line" series={CHART_DATA} options={chartOptions} height={250} />
    </Typography>
   

  );
}
